import React from "react";

interface WebPageEmbedProps {
  url: string; // Aquí es donde pasarás la URL del proxy,
  // por ejemplo, "/api/proxy/catalogo-reporte" en lugar de la URL directa "http://192.168.4.2/..."
}

export const WebPageEmbed: React.FC<WebPageEmbedProps> = ({ url }) => {
  // Este componente ya usa un <iframe> para embeber el contenido de la 'url'.
  // Si estás utilizando un proxy en el backend para evitar las restricciones de X-Frame-Options,
  // asegúrate de que la prop 'url' que pasas a este componente sea la ruta a tu endpoint del proxy.
  return (
    <div className="p-4">
      <div className="glass-effect glass-hover w-full h-[calc(100vh-8rem)] rounded-2xl overflow-hidden shadow-xl transition-all duration-300">
        <iframe
          src={url} // Esta 'url' será la URL de tu proxy
          className="w-full h-full border-none rounded-2xl"
          allow="clipboard-write"
          loading="lazy"
          // sandbox="allow-same-origin allow-scripts allow-popups allow-forms" // <-- LÍNEA ELIMINADA
          title="Embedded Page"
        />
      </div>
    </div>
  );
};
